import { render, staticRenderFns } from "./parksentrybox.vue?vue&type=template&id=f5968fa2&"
import script from "./parksentrybox.vue?vue&type=script&lang=js&"
export * from "./parksentrybox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports